import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import InputTabs from '../UI/InputTabs';
import Dialog from '../UI/Dialog';
import TextFields from '../UI/TextFiled';
import SwitchToggle from '../UI/SwitchToggle';
import Breadcrumb from '../UI/Breadcrumb';
import ImageUpload from '../UI/ImageUpload';
import menuItem from '../../assets/img/dummy_images/image-item.jpg';
import imgPlaceholder from '../../assets/img/img-placeholder.png';
import { getItems, addItem, editItem, getMenuName } from '../../store/actions';
import { Scrollbars } from 'react-custom-scrollbars';

import SearchForm from '../UI/SearchForm';
import Pagination from '../UI/Pagination';
import MultipleSelect from '../UI/MultipleSelect';
import ReactTooltip from 'react-tooltip';
import DeactivateDialog from './DeactivateDialog';
import PromptDialog from './PromptDialog';
import { validate } from '../../utils/constants';
import moment from "moment/moment";

// List item preview(background) image
const itemStyle = {
    backgroundImage: 'url(' + menuItem + ')'
};

class Item extends Component {

    state = {
        page: 1,
        searchedValue: null,
        isSingleViewDialogOpen: false,
        isAddItemDialogOpen: false,
        selected: null,
        isEditItemDialogOpen: false,
        isDeactivateDialogOpen: false,
        isCancelDeactivationDialogOpen: false,
        isDeletingDialogOpen: false,
        selectedItemId: null
    };

    componentDidMount() {
        this.props.getItems(this.props.match.params.menuId, 1, null);
        this.props.getMenuName(this.props.match.params.menuId);
    }

    openDeactivateDialog = (listId, isActive) => {
        this.changeStatus(listId, !isActive);
        // if (isActive) {
        //     this.setState({isDeactivateDialogOpen: true, deactivatingListId: listId});
        // } else {
        //     this.changeStatus(listId, true);
        // }
    };

    cancelDeactivation = () => {
        const data = { deactivation_date: null };
        this.props.editItem(this.state.cancelingDeactivationListId, data).then(res => {
            const { listId } = this.props.match.params;
            this.props.getItems(listId, this.state.page, this.state.searchedValue);
        });
        this.setState({ isCancelDeactivationDialogOpen: false, cancelingDeactivationListId: null })
    };

    changeStatus = (itemId, status, date) => {
        const data = { };
        if (date) {
            data.deactivation_date = moment(date).format('YYYY-MM-DD');
        } else {
            data.is_active = status
        }
        this.props.editItem(itemId, data).then(res => {
            const { menuId } = this.props.match.params;
            this.props.getItems(menuId, 1, null);
        });
    };

    onSubmitDeactivateStatusHandler = values => {
        if(values.deactivate && values.deactivate === 'deactivate_from' && values.date) {
            this.changeStatus(this.state.deactivatingListId, false, values.date);
        } else {
            this.changeStatus(this.state.deactivatingListId, false);
        }
        this.setState({isDeactivateDialogOpen: false});
    };

    deleteItem = () => {
        const data = { is_deleted: true };
        this.props.editItem(this.state.deletingListId, data).then(res => {
            const { listId } = this.props.match.params;
            this.props.getItems(listId, this.state.page, this.state.searchedValue);
        });
        this.setState({ isDeletingDialogOpen: false, deletingListId: null });
    };

    onSubmitAddItemHandler = values => {
        const data = {
            description_ar: values.description_ar,
            description_en: values.description_en,
            name_en: values.item_name_en,
            name_ar: values.item_name_ar,
            image: values.image,
            price: values.price,
            menu: +this.props.match.params.menuId
        };
        this.props.addItem(data).then(res => {
            this.props.getItems(this.props.match.params.menuId, 1, null);
            this.setState({isAddItemDialogOpen: false});
        })
    };
    onSearchChangeHandler = () => { };
    onSubmitSearchHandler = searchValue => this.props.getItems(this.props.match.params.listId, 1, searchValue);

    renderItems = () => {
        if (!this.props.items) return null;
        const items = this.props.items.map(item => {
            let deactivationDate = null;
            if (item.deactivation_date) {
                deactivationDate = (
                    <p>
                        <span className="color-grey50">Deactivated from: </span>
                        <span className="color-primary ml-5">{ item.deactivation_date }</span>
                    </p>
                );
            }
            return (
                <li className="card" key={item.id}>
                    <div className="action"
                         style={{cursor: 'pointer'}}
                         onClick={() => this.setState({isEditItemDialogOpen: true, selected: item}) } >

                        <a><i className="fa fa-pencil"></i></a>
                    </div>
                    <div className="inner-top">

                    </div>
                    <div className="inner pointer"
                         style={{ backgroundImage: 'url(' + item.image + ')'}}
                         onClick={() => this.setState({ isSingleViewDialogOpen: true, selected: item })}>
                        <h2>{ item.name_en }</h2>
                        <p>{item.price} SAR</p>
                    </div>
                    <div onClick={() => this.openDeactivateDialog(item.id, item.is_active)}
                         className="options text-center flex-center-y justify-between">
                        <p>Item Status</p>
                        <SwitchToggle notForm toggled={item.is_active}/>
                    </div>
                    <div className="action" style={{marginRight: '20px'}}>
                        {/*{deactivationDate && <Link to="#" onClick={ () => this.setState({ isCancelDeactivationDialogOpen: true, cancelingDeactivationListId: item.id }) }>*/}
                            {/*<span className="cancel">&#10006;</span>*/}
                        {/*</Link> }*/}
                        <Link to="#" className="color-red" onClick={() => this.setState({ isDeletingDialogOpen: true, deletingListId: item.id })}>
                            <span className="trash fa fa-trash"></span>
                        </Link>
                    </div>
                </li>
            );
        });
        return items;
    };

    onSubmitEditItemHandler = values => {
        this.props.editItem(this.state.selected.id, values).then(res => {
            this.props.getItems(+this.props.match.params.listId);
            this.setState({ isEditItemDialogOpen: false });
        })
    };

    render() {
        let pagination = null;
        if ( this.props.pageCount && this.props.pageCount > 1) {
            pagination = <Pagination pageChangeHandler={ this.pageChangeHandler }
                                     driversPageCount={ this.props.pageCount } />;
        }
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9 text-left">
                                <h1 className="color-grey">{this.props.menuName}</h1>
                            </div>
                            <SearchForm col onSubmit={ this.onSubmitSearchHandler }
                                        onChange={ this.onSearchChangeHandler } />
                        </div>
                    </div>
                </div>
                <div className="container">
                    <Breadcrumb from={[{link: '/customers', label: 'Customers Administration'},
                        {link: `/customers/${this.props.match.params.id}/edit`, label: 'Edit Customer'},
                        {link: `/customers/${this.props.match.params.id}/edit/${this.props.match.params.restId}/menu`, label: 'Add Menu'}]} current="Add Item"/>
                </div>
                <div className="container inner-padding box py-15">
                    <div className="box-body">
                        {/* START: Card Items Container */}
                        <ul className="card-items large image-items">
                            {/* START: Add New Card */}
                            <li className="card add">
                                <button className="no-style" onClick={() => this.setState({ isAddItemDialogOpen: true })}>
                                    <i className="fa fa-plus"></i>
                                    <p>Add New Item</p>
                                </button>
                            </li>
                            {/* END: Add New Card */}
                            { this.renderItems() }
                        </ul>
                        {/* END: Card Items Container */}
                    </div>
                </div>

                {/* START: Add List Popup */}
                {/*<Dialog  open={this.state.isAddItemDialogOpen} bodyClassName="p-0" handleClose={ () => this.setState({ isAddItemDialogOpen: false }) }>
                            <Form onSubmit={ this.onSubmitAddItemHandler }>
                                { formApi => (
                                    <form  onSubmit={formApi.submitForm}>
                                        <div>
                                            <div className="popup-title px-30 pt-30">
                                                <h2>Add Item</h2>
                                            </div>
                                            <Scrollbars
                                                autoHeight
                                                autoHeightMax={700}
                                            >
                                                <div className="px-30 pb-30">

                                                    <div className="popup-body">
                                                        <div className="row">
                                                            <div className="col-xs-8">
                                                                <InputTabs label="Item Name"
                                                                           validations={ [...validate.$required] }
                                                                           formApi={formApi}
                                                                           field="item_name"
                                                                           value="item_name" />
                                                            </div>
                                                            <div className="col-xs-4">
                                                             <TextFields label="Item Price SAR"
                                                             validations={ [...validate.$money] }
                                                             formApi={formApi}
                                                             field="price"></TextFields>
                                                             </div>
                                                        </div>

                                                        <div className="row align-end">
                                                            <div className="col-xs-5">
                                                                <TextFields formApi={formApi}
                                                                            type="text" label="Item Size"
                                                                            field="" />
                                                            </div>
                                                            <div className="col-xs-5">
                                                                <TextFields formApi={formApi}
                                                                            type="number" label="Side Dish price"
                                                                            field="" />
                                                            </div>
                                                            <div className="col-xs-2 pb-5">
                                                                <button className="no-style pointer">
                                                                    <i className="fa fa-plus-circle font-xl"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <ul className="tags  with-close mt-20">
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                        </ul>

                                                        <div className="row align-end pt-40">
                                                            <div className="col-xs-11">
                                                                <MultipleSelect/>
                                                            </div>
                                                        </div>
                                                        <ul className="tags with-close mt-10">
                                                            <li><span className="ellipsis" data-tip="Extra Large Extra Large Extra Large">Extra Large Extra Large Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                            <li><span className="ellipsis">Extra Large</span><span className="divider"></span><span>20 SAR</span><span className="divider divider-full"></span><span className="fa fa-times-circle close"></span></li>
                                                        </ul>
                                                        <ReactTooltip />


                                                        <ImageUpload validations={ [...validate.$image] } />
                                                        <div className="text-field">
                                                            <label className="label">Description</label>
                                                            <InputTabs textarea
                                                                       validations={ [...validate.$required] }
                                                                       formApi={formApi}
                                                                       field="description"
                                                                       value="description" />
                                                        </div>
                                                    </div>
                                                    <div className="popup-meta flex justify-end">
                                                        <button className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isAddItemDialogOpen: false }) }>Cancel</button>
                                                        <button className="btn filled primary min-120">Save</button>
                                                    </div>
                                                </div>
                                            </Scrollbars>
                                        </div>

                                    </form>
                                )}
                            </Form>
                            <button className="no-style close-btn" onClick={ () => this.setState({ isAddItemDialogOpen: false }) }>×</button>
                </Dialog>*/}
                <Dialog open={this.state.isAddItemDialogOpen} handleClose={ () => this.setState({ isAddItemDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitAddItemHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Add Item</h2>
                                </div>
                                <div className="popup-body">
                                    <div className="row">
                                        <div className="col-xs-8">
                                            <InputTabs label="Item Name"
                                                       validations={ [...validate.$required] }
                                                       formApi={formApi}
                                                       field="item_name"
                                                       value="item_name" />
                                        </div>
                                        <div className="col-xs-4">
                                            <TextFields label="Item Price SAR"
                                                        validations={ [...validate.$money] }
                                                        formApi={formApi}
                                                        field="price"></TextFields>
                                        </div>
                                    </div>
                                    <ImageUpload validations={ [...validate.$image] } />
                                    <div className="text-field">
                                        <label className="label">Description</label>
                                        <InputTabs textarea
                                                   validations={ [...validate.$required] }
                                                   formApi={formApi}
                                                   field="description"
                                                   value="description" />
                                    </div>
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isAddItemDialogOpen: false }) }>Cancel</button>
                                    <button className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isAddItemDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Add List Popup */}

                {/* START: Edit List Popup */}
                <Dialog open={this.state.isEditItemDialogOpen} handleClose={ () => this.setState({ isEditItemDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitEditItemHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Edit Item</h2>
                                </div>
                                <div className="popup-body">
                                    <div className="row">
                                        <div className="col-xs-8">
                                            <InputTabs label="Item Name"
                                                       defaultValue={this.state.selected.name_en}
                                                       validations={ [...validate.$required] }
                                                       formApi={formApi}
                                                       field="name"
                                                       value="name" />
                                        </div>
                                        <div className="col-xs-4">
                                            <TextFields label="Item Price SAR"
                                                        validations={ [...validate.$money] }
                                                        formApi={formApi}
                                                        field="price" defaultValue={this.state.selected.price}/>
                                        </div>
                                    </div>
                                    <ImageUpload defaultImage={this.state.selected.image}
                                                 validations={ [...validate.image] } />

                                    <div className="text-field">
                                        <label className="label">Description</label>
                                        <InputTabs textarea
                                                   defaultValue={this.state.selected.description_en}
                                                   validations={ [...validate.$required] }
                                                   formApi={formApi}
                                                   field="description"
                                                   value="description" />
                                    </div>
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isEditItemDialogOpen: false }) }>Cancel</button>
                                    <button className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isEditItemDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Edit List Popup */}

                {/* START: Item Single View Popup */}
                <Dialog open={this.state.isSingleViewDialogOpen} handleClose={ () => this.setState({ isSingleViewDialogOpen: false }) }>
                    <Form onSubmit={ this.submitted }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-body">
                                    <div className="flex">
                                        <div className="image-upload size-md my-20">
                                            <div className="image">
                                                {/* START: Replace this image after upload */}
                                                <img src={ this.state.selected.image ? this.state.selected.image : imgPlaceholder } alt="placeholder"/>
                                                {/* END: Replace this image after upload */}
                                            </div>
                                        </div>
                                        <ul className="ml-50 mt-10 w-700">
                                            <li className="py-15">
                                                <p className="font-sm color-grey50">Name</p>
                                                <p className="color-primary mt-5">{this.state.selected.name_en}</p>
                                            </li>
                                            <li className="py-15">
                                                <p className="font-sm color-grey50">Price</p>
                                                <p className="color-primary mt-5">{this.state.selected.price} SAR</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="py-15 w-700">
                                        <p className="font-sm color-grey50">Description</p>
                                        <p className="color-primary mt-5">{this.state.selected.description_en}</p>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isSingleViewDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Item Single View Popup */}

                <DeactivateDialog open={ this.state.isDeactivateDialogOpen }
                                  close={ () => this.setState({ isDeactivateDialogOpen: false }) }
                                  onSubmitDialog={ this.onSubmitDeactivateStatusHandler } />

                <PromptDialog open={ this.state.isCancelDeactivationDialogOpen }
                              prompt={'Are you sure you want to cancel the deactivation?'}
                              close={ () => this.setState({ isCancelDeactivationDialogOpen: false }) }
                              changeStatus={ this.cancelDeactivation }/>

                <PromptDialog open={ this.state.isDeletingDialogOpen }
                              prompt={'Are you sure you want to delete the list?'}
                              close={ () => this.setState({ isDeletingDialogOpen: false }) }
                              changeStatus={ this.deleteItem } />
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        items: state.customer.items,
        menuName: state.customer.menuName
    }
};


const mapDispatchToProps = dispatch => {
    return {
        getItems: (id, page, searchValue) => dispatch( getItems(id, page, searchValue) ),
        addItem: (data) => dispatch( addItem(data) ),
        editItem: (id, data) => dispatch( editItem(id, data) ),
        getMenuName: (id) => dispatch( getMenuName(id) )
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( Item );



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/Item.js